/**
 * @description 绘制实例 20260516 重构绘制核心算法
 * @author 1982392655@qq.com ~朴:shu
 * @time 20260516
 */
import Store from "../store";
import method from "./method";
import browser from "./browser";
import locale from "../locale/locale";
import { isRealNum } from "./validate";
import { getRealCellValue } from "./getdata";
import { getSheetIndex } from "../methods/get";
import menuButton from "../controllers/menuButton";
import pivotTable from "../controllers/pivotTable";
import { dynamicArrayCompute } from "./dynamicArray";
import sheetmanage from "../controllers/sheetmanage";
import { getBorderInfoComputeRange } from "./border";
import luckysheetSparkline from "../controllers/sparkline";
import conditionformat from "../controllers/conditionformat";
import alternateformat from "../controllers/alternateformat";
import { cellImageCtrl } from "../controllers/cellImageCtrl";
import { getMeasureText, getCellTextInfo } from "./getRowlen";
import { getObjType, luckysheetfontformat } from "../utils/util";
import { cellProtectionCtrl } from "../controllers/cellProtection";
import dataVerificationCtrl from "../controllers/dataVerificationCtrl";
import { getSlashMergeCell, drawBorder, getCellOverflowMap, handleFillStyle } from "../utils/draw";
import { luckysheet_CFiconsImg, luckysheetdefaultFont } from "../controllers/constant";
import { handleCellOverflow, parseMergeCellData, cellOverflow_colIn } from "../utils/draw";
import { luckysheetDrawgridRowTitle, luckysheetDrawgridColumnTitle } from "../utils/draw";
import { parseDrawContext, getRenderAreaRange, parseCellData, drawCellBorder, initCanvas } from "../utils/draw";
import { highlightCellCtrl } from "../controllers/highlightCellCtrl";

/**
 * @description luckysheetDrawMain 绘制主函数
 *  为了解决 参数传递 的二义性，使用 options 对象传递参数，避免直接传递多个不明含义的参数
 * @param {Object} options - 绘制选项对象
 * @param {Number} options.scrollWidth - 滚动宽度
 * @param {Number} options.scrollHeight - 滚动高度
 * @param {Number} options.drawWidth - 绘制宽度
 * @param {Number} options.drawHeight - 绘制高度
 * @param {Number} options.offsetLeft - 偏移左坐标 [null]
 * @param {Number} options.offsetTop - 偏移上坐标 [null]
 * @param {Number} options.columnOffsetCell - 列偏移单元格数 [null]
 * @param {Number} options.rowOffsetCell - 行偏移单元格数 [null]
 * @param {CanvasElement2D} options.canvas - 画布元素
 * @param {Number} options.devicePixelRatio - 设备像素比 [null]
 * @param {Boolean} options.printGridLine - 是否打印网格线 [true]
 * @param {Boolean} options.isPrint - 是否处于打印模式 [false]
 *
 */
function luckysheetDrawMain(options = {}) {
    // 检查 flowdata 是否存在
    if (Store.flowdata == null) return;

    clearTimeout(Store.measureTextCacheTimeOut);

    // 解析对应的参数
    let { scrollWidth, scrollHeight, drawWidth, drawHeight, offsetLeft, offsetTop } = options;
    let { columnOffsetCell, rowOffsetCell, canvas, devicePixelRatio } = options;
    const { printGridLine = true, isPrint = false } = options;

    // 参数未定义兼容处理
    if (scrollWidth == null) scrollWidth = $("#luckysheet-cell-main").scrollLeft();
    if (scrollHeight == null) scrollHeight = $("#luckysheet-cell-main").scrollTop();
    if (drawWidth == null) drawWidth = Store.luckysheetTableContentHW[0];
    if (drawHeight == null) drawHeight = Store.luckysheetTableContentHW[1];
    if (offsetLeft == null) offsetLeft = Store.rowHeaderWidth;
    if (offsetTop == null) offsetTop = Store.columnHeaderHeight;
    if (columnOffsetCell == null) columnOffsetCell = 0;
    if (rowOffsetCell == null) rowOffsetCell = 0;
    if (devicePixelRatio == null) devicePixelRatio = Store.devicePixelRatio;
    // 至 20260518 起，不再支持 border05 参数，避免计算过程中，过多的 +1 -1 导致的逻辑错误

    /** ⛔️ 注意： 原有的代码结构，是将 scrollWidth scrollHeight ... 等参数直接传递到对应的函数形参中，导致函数参数过于长，不便于查阅 */
    // 这些参数是在这个函数周期内生效，不需要担心引用对象的问题
    const drawParams = {};
    Object.assign(drawParams, { devicePixelRatio, printGridLine, isPrint });
    Object.assign(drawParams, { scrollWidth, scrollHeight, drawWidth, drawHeight });
    Object.assign(drawParams, { offsetLeft: offsetLeft - 1, offsetTop: offsetTop - 1, columnOffsetCell, rowOffsetCell });

    // 获取表格绘制上下文
    const tableCtx = parseDrawContext(canvas);

    // 表格渲染区域 起止行列坐标
    const rangeInfo = getRenderAreaRange(drawParams);

    // ⚠️ 重要步骤：
    Object.assign(drawParams, { ...rangeInfo });

    // Step 1 初始化画布 - 设置缩放 清除画布 填充矩形
    initCanvas(tableCtx, drawParams);

    // 钩子函数
    method.createHookFunction("cellAllRenderBefore", Store.flowdata, sheetmanage.getSheetByIndex(), tableCtx);

    // Step 2 解析单元格数据 cellupdate borderOffset
    const { cellupdate, borderOffset } = parseCellData(drawParams);

    // Step 3 动态数组公式计算
    const dynamicArray_compute = dynamicArrayCompute(Store.luckysheetfile[getSheetIndex(Store.currentSheetIndex)]["dynamicArray"]);

    // Step 4 交替颜色计算
    const af_compute = alternateformat.getComputeMap();

    // Step 5 条件格式计算
    const cf_compute = conditionformat.getComputeMap();

    // Step 6 获取单元格溢出数据
    const cellOverflowMap = getCellOverflowMap(tableCtx, drawParams);

    // 重要步骤：缓存参数
    Object.assign(drawParams, { af_compute, cf_compute, cellOverflowMap, dynamicArray_compute });

    // Step 7 渲染单元格数据 cellupdate 在内部进行单元格的绘制，包括 nullcell entitycell
    renderCell(tableCtx, cellupdate, drawParams);

    // Step 8 处理合并单元格数据
    renderMergeCell(tableCtx, cellupdate, drawParams);

    // Step 9 数据透视表边框渲染
    renderPivotTableBorder(tableCtx, drawParams);

    // Step 10 绘制边框 - borderInfo 这个是 File.config["borderInfo"] 的边框
    renderBorderInfo(borderOffset, tableCtx, drawParams);

    // Step 11 渲染表格时有尾列时，清除右边灰色区域，防止表格有值溢出
    handleCellOverflow(tableCtx, drawParams);

    // Step 12 所有的单元格都绘制完成后，开始处理单元格保护功能(某些单元格需要控制某些人只读，因此，需要绘制禁止编辑框)
    cellProtectionCtrl.render({ tableCtx, offsetLeft, offsetTop, scrollWidth, scrollHeight });

    // Step 13 恢复画布状态，避免影响后续绘制
    tableCtx.restore();

    // Step 14 清除缓存
    Store.measureTextCacheTimeOut = setTimeout(() => {
        Store.measureTextCache = {};
        Store.measureTextCellInfoCache = {};
        Store.cellOverflowMapCache = {};
    }, 100);
}

/**
 * @description 渲染单元格数据
 */
function renderCell(tableCtx, celldata, drawParams) {
    if (celldata.length === 0) return;

    const { printGridLine, offsetLeft, offsetTop } = drawParams;

    for (let cell of celldata) {
        // 解析对应的参数
        const { r, c, start_r, start_c } = cell;

        // 检查对应行是否存在
        if (Store.flowdata[r] == null) continue;

        // 检查对应的列是否存在
        if (Store.flowdata[r][c] == null) {
            // 这里需要判定是否需要绘制空单元格 ，因为打印场景下 需要隐藏边线
            renderEmptyCell({ tableCtx, cellInfo: cell, drawParams });
            // 为空直接跳过
            continue;
        }

        // 非空单元格
        const cellItem = Store.flowdata[r][c];
        let value = null;

        // 判定单元格是否是合并单元格
        if (typeof cellItem == "object" && "mc" in cellItem) {
            // 不需要处理
        } else {
            value = getRealCellValue(r, c);
        }

        // 到这里，如果 value 的值还是 null ，说明是空单元格
        if (value == null || value.toString().length == 0) {
            renderEmptyCell({ tableCtx, cellInfo: cell, drawParams });

            // 执行sparklines渲染
            let borderfix = menuButton.borderfix(Store.flowdata, r, c);
            const offsetX = start_c + offsetLeft + borderfix[0];
            const offsetY = start_r + offsetTop + borderfix[1];
            renderSparklines(r, c, offsetX, offsetY, "tableCtx", tableCtx);
        }
        // 这里则表示单元格有值
        else {
            const dynamicArray_compute = dynamicArrayCompute(Store.luckysheetfile[getSheetIndex(Store.currentSheetIndex)]["dynamicArray"]);

            if (r + "_" + c in dynamicArray_compute) {
                //动态数组公式
                value = dynamicArray_compute[r + "_" + c].v;
            }

            // 执行entitycell渲染
            renderEntityCell({ tableCtx, cellInfo: { ...cell, value }, drawParams });
        }

        // 兼容下 DISPIMG 类型的单元格
        if (cellItem.f && cellItem.f.includes("DISPIMG")) {
            renderCellImage(tableCtx, cellItem.f, cell, drawParams);
        }
    }
}

/**
 * @description 渲染sparklines
 */
function renderSparklines(r, c, offsetX, offsetY, canvasid, ctx) {
    if (Store.flowdata[r] == null || Store.flowdata[r][c] == null) {
        return;
    }

    let sparklines = Store.flowdata[r][c].spl;
    if (sparklines != null) {
        if (typeof sparklines == "string") {
            sparklines = new Function("return " + sparklines)();
        }

        if (getObjType(sparklines) == "object") {
            let temp1 = sparklines;
            let x = temp1.offsetX;
            let y = temp1.offsetY;
            x = x == null ? 0 : x;
            y = y == null ? 0 : y;
            luckysheetSparkline.render(temp1.shapeseq, temp1.shapes, offsetX + x, offsetY + y, temp1.pixelWidth, temp1.pixelHeight, canvasid, ctx);
        } else if (getObjType(sparklines) == "array" && getObjType(sparklines[0]) == "object") {
            for (let i = 0; i < sparklines.length; i++) {
                let temp1 = sparklines[i];
                let x = temp1.offsetX;
                let y = temp1.offsetY;
                x = x == null ? 0 : x;
                y = y == null ? 0 : y;
                luckysheetSparkline.render(temp1.shapeseq, temp1.shapes, offsetX + x, offsetY + y, temp1.pixelWidth, temp1.pixelHeight, canvasid, ctx);
            }
        }
    }
}

/**
 * @description 渲染空单元格
 */
function renderEmptyCell(options = {}) {
    // 这里参数过多了，建议合并处理
    const { cellInfo, tableCtx, isMerge = false, drawParams } = options;

    // 单元格属性
    const { r, c, start_r, start_c, end_r, end_c } = cellInfo;

    // 原生参数
    const { offsetLeft, offsetTop, dataset_col_st, dataset_col_ed, printGridLine } = drawParams;

    // 计算属性
    const { af_compute, cf_compute, dynamicArray_compute, cellOverflowMap } = drawParams;

    const checksAF = alternateformat.checksAF(r, c, af_compute); //交替颜色
    const checksCF = conditionformat.checksCF(r, c, cf_compute); //条件格式
    const borderfix = menuButton.borderfix(Store.flowdata, r, c);
    let fillStyle = menuButton.checkstatus(Store.flowdata, r, c, "bg"); //背景色

    //交替颜色
    if (checksAF != null && checksAF[1] != null) fillStyle = checksAF[1];
    //条件格式
    if (checksCF != null && checksCF["cellColor"] != null) fillStyle = checksCF["cellColor"];
    //标题色
    if (Store.flowdata[r][c] != null && Store.flowdata[r][c].tc != null) fillStyle = Store.flowdata[r][c].tc;

    // 处理单元格颜色
    tableCtx.fillStyle = handleFillStyle(fillStyle, r, c);

    /**
     * @description 这里绘制单元格的矩形范围时，有一个注意事项：
     *  1. 需要预留边框的宽度，不然绘制出来的边框，会和 fillRect 重叠，导致颜色叠加
     *  2. 此版本的解决方案是，在绘制时，填充白色，避免颜色叠加
     */

    let cellsize = [
        start_c + offsetLeft + borderfix[0],
        start_r + offsetTop + borderfix[1],
        end_c - start_c + borderfix[2] - (!!isMerge ? 1 : 0),
        end_r - start_r + borderfix[3],
    ];

    //单元格渲染前，考虑到合并单元格会再次渲染一遍，统一放到这里
    if (
        !method.createHookFunction(
            "cellRenderBefore",
            Store.flowdata[r][c],
            {
                r: r,
                c: c,
                start_r: cellsize[1],
                start_c: cellsize[0],
                end_r: cellsize[3] + cellsize[1],
                end_c: cellsize[2] + cellsize[0],
            },
            sheetmanage.getSheetByIndex(),
            tableCtx,
        )
    ) {
        return;
    }

    tableCtx.fillRect(cellsize[0], cellsize[1], cellsize[2], cellsize[3]);

    if (r + "_" + c in dynamicArray_compute) {
        let value = dynamicArray_compute[r + "_" + c].v;

        tableCtx.fillStyle = "#000000";
        //文本宽度和高度
        let fontset = luckysheetdefaultFont();
        tableCtx.font = fontset;

        //水平对齐 (默认为1，左对齐)
        let horizonAlignPos = start_c + 4 + offsetLeft;

        //垂直对齐 (默认为2，下对齐)
        let verticalFixed = browser.luckysheetrefreshfixed();
        let verticalAlignPos = end_r + offsetTop - 1;
        tableCtx.textBaseline = "bottom";

        tableCtx.fillText(value == null ? "" : value, horizonAlignPos, verticalAlignPos);
    }

    //若单元格有批注
    if (Store.flowdata[r][c] != null && Store.flowdata[r][c].ps != null) {
        let ps_w = 8 * Store.zoomRatio,
            ps_h = 8 * Store.zoomRatio;
        tableCtx.beginPath();
        tableCtx.moveTo(end_c + offsetLeft - 1 - ps_w, start_r + offsetTop);
        tableCtx.lineTo(end_c + offsetLeft - 1, start_r + offsetTop);
        tableCtx.lineTo(end_c + offsetLeft - 1, start_r + offsetTop + ps_h);
        tableCtx.fillStyle = "#FC6666";
        tableCtx.fill();
        tableCtx.closePath();
    }

    //此单元格 与  溢出单元格关系
    const { colLast, rowIndex, colIndex, stc, edc, colIn } = cellOverflow_colIn(cellOverflowMap, r, c, dataset_col_st, dataset_col_ed);

    //此单元格 为 溢出单元格渲染范围最后一列，绘制溢出单元格内容
    if (colLast) {
        cellOverflowRender(rowIndex, colIndex, stc, edc, tableCtx, drawParams);
    }

    // 这里取的是单元格的位置宽高
    const [x, y, w, h] = cellsize;

    //  右边框 即溢出单元格跨此单元格，此单元格不绘制右边框
    if (!colIn || colLast) {
        // 无论是否有背景色，都默认绘制右边框
        if (!Store.luckysheetcurrentisPivotTable && Store.showGridLines && printGridLine) {
            const moveX = x + w;
            const moveY = y;
            const lineX = x + w;
            const lineY = y + h;
            drawCellBorder(tableCtx, moveX, moveY, lineX, lineY);
        }
    }

    // 下边框
    // 无论是否有背景色，都默认绘制下边框
    if (!Store.luckysheetcurrentisPivotTable && Store.showGridLines && printGridLine) {
        const moveX = x;
        const moveY = y + h;
        const lineX = x + w;
        const lineY = y + h;
        drawCellBorder(tableCtx, moveX, moveY, lineX, lineY);
    }

    // 解决打印时，左上边框不显示问题
    if (drawParams.isPrint && drawParams.printGridLine) {
        renderPrintBorder(tableCtx, r, c, cellsize);
    }

    // 单元格渲染后
    method.createHookFunction(
        "cellRenderAfter",
        Store.flowdata[r][c],
        {
            r: r,
            c: c,
            start_r: cellsize[1],
            start_c: cellsize[0],
            end_r: cellsize[3] + cellsize[1],
            end_c: cellsize[2] + cellsize[0],
        },
        sheetmanage.getSheetByIndex(),
        tableCtx,
    );
}
/**
 * @description 渲染实体单元格 - 有值的 有内容的 单元格(可能是 bg  txt  等)
 */
function renderEntityCell(options = {}) {
    const { cellInfo, tableCtx, isMerge = false, drawParams } = options;

    // 单元格属性
    const { r, c, start_r, start_c, end_r, end_c, value } = cellInfo;
    // 原生参数
    const { offsetLeft, offsetTop, dataset_col_st, dataset_col_ed, printGridLine } = drawParams;

    // 计算属性
    const { af_compute, cf_compute, cellOverflowMap } = drawParams;
    let cell = Store.flowdata[r][c];
    let cellWidth = end_c - start_c - 2;
    let cellHeight = end_r - start_r - 2;
    let space_width = 2,
        space_height = 2; //宽高方向 间隙

    //水平对齐
    let horizonAlign = menuButton.checkstatus(Store.flowdata, r, c, "ht");
    //垂直对齐
    let verticalAlign = menuButton.checkstatus(Store.flowdata, r, c, "vt");

    //交替颜色
    let checksAF = alternateformat.checksAF(r, c, af_compute);
    //条件格式
    let checksCF = conditionformat.checksCF(r, c, cf_compute);

    //单元格 背景颜色
    let fillStyle = menuButton.checkstatus(Store.flowdata, r, c, "bg");
    if (checksAF != null && checksAF[1] != null) {
        //若单元格有交替颜色 背景颜色
        fillStyle = checksAF[1];
    }
    if (checksCF != null && checksCF["cellColor"] != null) {
        //若单元格有条件格式 背景颜色
        fillStyle = checksCF["cellColor"];
    }

    // tableCtx.textBaseline = 'top';
    // if (fillStyle == null) {
    //     // 20260516 这里是为了实现高亮行列功能，设置的透明色，不然有值的单元格，都会被渲染成白色，不符合逻辑
    //     tableCtx.fillStyle = "transparent";
    // } else {
    //     tableCtx.fillStyle = fillStyle;
    // }
    tableCtx.fillStyle = handleFillStyle(fillStyle, r, c);

    let borderfix = menuButton.borderfix(Store.flowdata, r, c);

    // 这里计算canvas需要绘制的矩形范围时,需要留下原本单元格边框的位置
    // 让 fillRect 绘制矩形的起始xy坐标增加1,绘制长宽减少1

    let cellsize = [
        start_c + offsetLeft + borderfix[0],
        start_r + offsetTop + borderfix[1],
        end_c - start_c + borderfix[2] - (!!isMerge ? 1 : 0),
        end_r - start_r + borderfix[3],
    ];

    //单元格渲染前，考虑到合并单元格会再次渲染一遍，统一放到这里
    if (
        !method.createHookFunction(
            "cellRenderBefore",
            Store.flowdata[r][c],
            {
                r: r,
                c: c,
                start_r: cellsize[1],
                start_c: cellsize[0],
                end_r: cellsize[3] + cellsize[1],
                end_c: cellsize[2] + cellsize[0],
            },
            sheetmanage.getSheetByIndex(),
            tableCtx,
        )
    ) {
        return;
    }
    // 这里 为了解决填充透明色，会导致多左上的 0.5边框厚度问题
    tableCtx.clearRect(cellsize[0], cellsize[1], cellsize[2], cellsize[3]);
    // 这个填充是为了渲染单元格的背景颜色
    tableCtx.fillRect(cellsize[0], cellsize[1], cellsize[2], cellsize[3]);

    let dataVerification = dataVerificationCtrl.dataVerification;

    // 数据验证
    if (dataVerification != null && dataVerification[r + "_" + c] != null && !dataVerificationCtrl.validateCellData(value, dataVerification[r + "_" + c])) {
        //单元格左上角红色小三角标示
        let dv_w = 5 * Store.zoomRatio,
            dv_h = 5 * Store.zoomRatio; //红色小三角宽高

        tableCtx.beginPath();
        tableCtx.moveTo(start_c + offsetLeft, start_r + offsetTop);
        tableCtx.lineTo(start_c + offsetLeft + dv_w, start_r + offsetTop);
        tableCtx.lineTo(start_c + offsetLeft, start_r + offsetTop + dv_h);
        tableCtx.fillStyle = "#FC6666";
        tableCtx.fill();
        tableCtx.closePath();
    }

    //若单元格有批注（单元格右上角红色小三角标示）
    if (cell.ps != null) {
        let ps_w = 8 * Store.zoomRatio,
            ps_h = 8 * Store.zoomRatio; //红色小三角宽高

        tableCtx.beginPath();
        tableCtx.moveTo(end_c + offsetLeft - ps_w, start_r + offsetTop);
        tableCtx.lineTo(end_c + offsetLeft, start_r + offsetTop);
        tableCtx.lineTo(end_c + offsetLeft, start_r + offsetTop + ps_h);
        tableCtx.fillStyle = "#FC6666";
        tableCtx.fill();
        tableCtx.closePath();
    }

    //若单元格强制为字符串，则显示绿色小三角
    if (cell.qp == 1 && isRealNum(cell.v)) {
        let ps_w = 6 * Store.zoomRatio,
            ps_h = 6 * Store.zoomRatio; //红色小三角宽高

        tableCtx.beginPath();
        tableCtx.moveTo(start_c + offsetLeft + ps_w - 1, start_r + offsetTop);
        tableCtx.lineTo(start_c + offsetLeft - 1, start_r + offsetTop);
        tableCtx.lineTo(start_c + offsetLeft - 1, start_r + offsetTop + ps_h);
        tableCtx.fillStyle = "#487f1e";
        tableCtx.fill();
        tableCtx.closePath();
    }

    //溢出单元格
    let cellOverflow_bd_r_render = true; //溢出单元格右边框是否需要绘制
    let { colIn, colLast, rowIndex, colIndex, stc, edc } = cellOverflow_colIn(cellOverflowMap, r, c, dataset_col_st, dataset_col_ed);

    if (cell.tb == "1" && colIn) {
        //此单元格 为 溢出单元格渲染范围最后一列，绘制溢出单元格内容
        if (colLast) {
            cellOverflowRender(rowIndex, colIndex, stc, edc, tableCtx, drawParams);
        } else {
            cellOverflow_bd_r_render = false;
        }
    }
    //数据验证 复选框
    else if (dataVerification != null && dataVerification[r + "_" + c] != null && dataVerification[r + "_" + c].type == "checkbox") {
        let pos_x = start_c + offsetLeft;
        let pos_y = start_r + offsetTop + 1;

        tableCtx.save();
        tableCtx.beginPath();
        tableCtx.rect(pos_x, pos_y, cellWidth, cellHeight);
        tableCtx.clip();
        tableCtx.scale(Store.zoomRatio, Store.zoomRatio);

        let measureText = getMeasureText(value, tableCtx);
        let textMetrics = measureText.width + 14;
        let oneLineTextHeight = measureText.actualBoundingBoxDescent + measureText.actualBoundingBoxAscent;

        let horizonAlignPos = pos_x + space_width; //默认为1，左对齐
        if (horizonAlign == "0") {
            //居中对齐
            horizonAlignPos = pos_x + cellWidth / 2 - textMetrics / 2;
        } else if (horizonAlign == "2") {
            //右对齐
            horizonAlignPos = pos_x + cellWidth - space_width - textMetrics;
        }

        let verticalCellHeight = cellHeight > oneLineTextHeight ? cellHeight : oneLineTextHeight;

        let verticalAlignPos_text = pos_y + verticalCellHeight - space_height; //文本垂直方向基准线
        tableCtx.textBaseline = "bottom";
        let verticalAlignPos_checkbox = verticalAlignPos_text - 13 * Store.zoomRatio;

        if (verticalAlign == "0") {
            //居中对齐
            verticalAlignPos_text = pos_y + verticalCellHeight / 2;
            tableCtx.textBaseline = "middle";
            verticalAlignPos_checkbox = verticalAlignPos_text - 6 * Store.zoomRatio;
        } else if (verticalAlign == "1") {
            //上对齐
            verticalAlignPos_text = pos_y + space_height;
            tableCtx.textBaseline = "top";
            verticalAlignPos_checkbox = verticalAlignPos_text + 1 * Store.zoomRatio;
        }

        horizonAlignPos = horizonAlignPos / Store.zoomRatio;
        verticalAlignPos_text = verticalAlignPos_text / Store.zoomRatio;
        verticalAlignPos_checkbox = verticalAlignPos_checkbox / Store.zoomRatio;

        //复选框
        tableCtx.lineWidth = 1;
        tableCtx.strokeStyle = "#000";
        tableCtx.strokeRect(horizonAlignPos, verticalAlignPos_checkbox, 10, 10);

        if (dataVerification[r + "_" + c].checked) {
            tableCtx.beginPath();
            tableCtx.lineTo(horizonAlignPos + 1, verticalAlignPos_checkbox + 6);
            tableCtx.lineTo(horizonAlignPos + 4, verticalAlignPos_checkbox + 9);
            tableCtx.lineTo(horizonAlignPos + 9, verticalAlignPos_checkbox + 2);
            tableCtx.stroke();
            tableCtx.closePath();
        }

        //文本
        tableCtx.fillStyle = menuButton.checkstatus(Store.flowdata, r, c, "fc");
        tableCtx.fillText(value == null ? "" : value, horizonAlignPos + 14, verticalAlignPos_text);

        tableCtx.restore();
    } else {
        //若单元格有条件格式数据条
        if (checksCF != null && checksCF["dataBar"] != null && checksCF["dataBar"]["valueLen"] && checksCF["dataBar"]["valueLen"].toString() !== "NaN") {
            let x = start_c + offsetLeft + space_width;
            let y = start_r + offsetTop + space_height;
            let w = cellWidth - space_width * 2;
            let h = cellHeight - space_height * 2;

            let valueType = checksCF["dataBar"]["valueType"];
            let valueLen = checksCF["dataBar"]["valueLen"];
            let format = checksCF["dataBar"]["format"];

            if (valueType == "minus") {
                //负数
                let minusLen = checksCF["dataBar"]["minusLen"];

                if (format.length > 1) {
                    //渐变
                    let my_gradient = tableCtx.createLinearGradient(x + w * minusLen * (1 - valueLen), y, x + w * minusLen, y);
                    my_gradient.addColorStop(0, "#ffffff");
                    my_gradient.addColorStop(1, "#ff0000");

                    tableCtx.fillStyle = my_gradient;
                } else {
                    //单色
                    tableCtx.fillStyle = "#ff0000";
                }

                tableCtx.fillRect(x + w * minusLen * (1 - valueLen), y, w * minusLen * valueLen, h);

                tableCtx.beginPath();
                tableCtx.moveTo(x + w * minusLen * (1 - valueLen), y);
                tableCtx.lineTo(x + w * minusLen * (1 - valueLen), y + h);
                tableCtx.lineTo(x + w * minusLen, y + h);
                tableCtx.lineTo(x + w * minusLen, y);
                tableCtx.lineTo(x + w * minusLen * (1 - valueLen), y);
                tableCtx.lineWidth = 1;
                tableCtx.strokeStyle = "#ff0000";
                tableCtx.stroke();
                tableCtx.closePath();
            } else if (valueType == "plus") {
                //正数
                let plusLen = checksCF["dataBar"]["plusLen"];

                if (plusLen == 1) {
                    if (format.length > 1) {
                        //渐变
                        let my_gradient = tableCtx.createLinearGradient(x, y, x + w * valueLen, y);
                        my_gradient.addColorStop(0, format[0]);
                        my_gradient.addColorStop(1, format[1]);

                        tableCtx.fillStyle = my_gradient;
                    } else {
                        //单色
                        tableCtx.fillStyle = format[0];
                    }

                    tableCtx.fillRect(x, y, w * valueLen, h);

                    tableCtx.beginPath();
                    tableCtx.moveTo(x, y);
                    tableCtx.lineTo(x, y + h);
                    tableCtx.lineTo(x + w * valueLen, y + h);
                    tableCtx.lineTo(x + w * valueLen, y);
                    tableCtx.lineTo(x, y);
                    tableCtx.lineWidth = 1;
                    tableCtx.strokeStyle = format[0];
                    tableCtx.stroke();
                    tableCtx.closePath();
                } else {
                    let minusLen = checksCF["dataBar"]["minusLen"];

                    if (format.length > 1) {
                        //渐变
                        let my_gradient = tableCtx.createLinearGradient(x + w * minusLen, y, x + w * minusLen + w * plusLen * valueLen, y);
                        my_gradient.addColorStop(0, format[0]);
                        my_gradient.addColorStop(1, format[1]);

                        tableCtx.fillStyle = my_gradient;
                    } else {
                        //单色
                        tableCtx.fillStyle = format[0];
                    }

                    tableCtx.fillRect(x + w * minusLen, y, w * plusLen * valueLen, h);

                    tableCtx.beginPath();
                    tableCtx.moveTo(x + w * minusLen, y);
                    tableCtx.lineTo(x + w * minusLen, y + h);
                    tableCtx.lineTo(x + w * minusLen + w * plusLen * valueLen, y + h);
                    tableCtx.lineTo(x + w * minusLen + w * plusLen * valueLen, y);
                    tableCtx.lineTo(x + w * minusLen, y);
                    tableCtx.lineWidth = 1;
                    tableCtx.strokeStyle = format[0];
                    tableCtx.stroke();
                    tableCtx.closePath();
                }
            }
        }

        let pos_x = start_c + offsetLeft;
        let pos_y = start_r + offsetTop + 1;

        tableCtx.save();
        tableCtx.beginPath();
        tableCtx.rect(pos_x, pos_y, cellWidth, cellHeight);
        tableCtx.clip();
        tableCtx.scale(Store.zoomRatio, Store.zoomRatio);

        let textInfo = getCellTextInfo(cell, tableCtx, {
            cellWidth: cellWidth,
            cellHeight: cellHeight,
            space_width: space_width,
            space_height: space_height,
            r: r,
            c: c,
        });

        //若单元格有条件格式图标集
        if (checksCF != null && checksCF["icons"] != null && textInfo.type == "plain") {
            let l = checksCF["icons"]["left"];
            let t = checksCF["icons"]["top"];

            let value = textInfo.values[0];
            let horizonAlignPos = pos_x + value.left;
            let verticalAlignPos = pos_y + value.top - textInfo.textHeightAll;

            if (verticalAlign == "0") {
                //居中对齐
                verticalAlignPos = pos_y + cellHeight / 2 - textInfo.textHeightAll / 2;
            } else if (verticalAlign == "1") {
                //上对齐
                verticalAlignPos = pos_y;
            } else if (verticalAlign == "2") {
                //下对齐
                verticalAlignPos = verticalAlignPos - textInfo.desc;
            }

            verticalAlignPos = verticalAlignPos / Store.zoomRatio;
            horizonAlignPos = horizonAlignPos / Store.zoomRatio;

            tableCtx.drawImage(
                luckysheet_CFiconsImg,
                l * 42,
                t * 32,
                32,
                32,
                pos_x / Store.zoomRatio,
                verticalAlignPos,
                textInfo.textHeightAll / Store.zoomRatio,
                textInfo.textHeightAll / Store.zoomRatio,
            );

            if (horizonAlign != "0" && horizonAlign != "2") {
                //左对齐时 文本渲染空出一个图标的距离
                horizonAlignPos = horizonAlignPos + textInfo.textHeightAll / Store.zoomRatio;
            }
        }

        //单元格 文本颜色
        tableCtx.fillStyle = menuButton.checkstatus(Store.flowdata, r, c, "fc");

        //若单元格有交替颜色 文本颜色
        if (checksAF != null && checksAF[0] != null) {
            tableCtx.fillStyle = checksAF[0];
        }
        //若单元格有条件格式 文本颜色
        if (checksCF != null && checksCF["textColor"] != null) {
            tableCtx.fillStyle = checksCF["textColor"];
        }

        //若单元格格式为自定义数字格式（[red]） 文本颜色为红色
        if (cell.ct && cell.ct.fa && cell.ct.fa.indexOf("[Red]") > -1 && cell.ct.t == "n" && cell.v < 0) {
            tableCtx.fillStyle = "#ff0000";
        }

        renderCellText(textInfo, tableCtx, {
            pos_x: pos_x,
            pos_y: pos_y,
            visible: cellProtectionCtrl.isVisible(r, c),
        });

        tableCtx.restore();
    }

    // 这里取的是单元格的位置宽高
    const [x, y, w, h] = cellsize;

    // 右边框
    // 无论是否有背景色，都默认绘制右边框
    if (cellOverflow_bd_r_render) {
        if (!Store.luckysheetcurrentisPivotTable && Store.showGridLines && printGridLine) {
            const moveX = x + w;
            const moveY = y;
            const lineX = x + w;
            const lineY = y + h;
            drawCellBorder(tableCtx, moveX, moveY, lineX, lineY);
        }
    }

    // 下边框
    // 无论是否有背景色，都默认绘制下边框
    if (!Store.luckysheetcurrentisPivotTable && Store.showGridLines && printGridLine) {
        const moveX = x;
        const moveY = y + h;
        const lineX = x + w;
        const lineY = y + h; // 下边框则 y 值相同
        drawCellBorder(tableCtx, moveX, moveY, lineX, lineY);
    }

    // 解决打印时，左上边框不显示问题
    if (drawParams.isPrint && drawParams.printGridLine) {
        renderPrintBorder(tableCtx, r, c, cellsize);
    }

    // 单元格渲染后
    method.createHookFunction(
        "cellRenderAfter",
        Store.flowdata[r][c],
        {
            r: r,
            c: c,
            start_r: cellsize[1],
            start_c: cellsize[0],
            end_r: cellsize[3] + cellsize[1],
            end_c: cellsize[2] + cellsize[0],
        },
        sheetmanage.getSheetByIndex(),
        tableCtx,
    );
}

//溢出单元格渲染
function cellOverflowRender(r, c, stc, edc, tableCtx, drawParams) {
    const { scrollHeight, scrollWidth, offsetLeft, offsetTop, af_compute, cf_compute } = drawParams;
    //溢出单元格 起止行列坐标
    let start_r;
    if (r == 0) {
        start_r = -scrollHeight - 1;
    } else {
        start_r = Store.visibledatarow[r - 1] - scrollHeight - 1;
    }

    let end_r = Store.visibledatarow[r] - scrollHeight;

    let start_c;
    if (stc == 0) {
        start_c = -scrollWidth;
    } else {
        start_c = Store.visibledatacolumn[stc - 1] - scrollWidth;
    }

    let end_c = Store.visibledatacolumn[edc] - scrollWidth;

    //
    let cell = Store.flowdata[r][c];
    let cellWidth = end_c - start_c - 2;
    let cellHeight = end_r - start_r - 2;
    let space_width = 2,
        space_height = 2; //宽高方向 间隙

    let pos_x = start_c + offsetLeft;
    let pos_y = start_r + offsetTop + 1;

    let fontset = luckysheetfontformat(cell);
    tableCtx.font = fontset;

    tableCtx.save();
    tableCtx.beginPath();
    tableCtx.rect(pos_x, pos_y, cellWidth, cellHeight);
    tableCtx.clip();
    tableCtx.scale(Store.zoomRatio, Store.zoomRatio);

    let textInfo = getCellTextInfo(cell, tableCtx, {
        cellWidth: cellWidth,
        cellHeight: cellHeight,
        space_width: space_width,
        space_height: space_height,
        r: r,
        c: c,
    });

    //交替颜色
    let checksAF = alternateformat.checksAF(r, c, af_compute);
    //条件格式
    let checksCF = conditionformat.checksCF(r, c, cf_compute);

    //单元格 文本颜色
    tableCtx.fillStyle = menuButton.checkstatus(Store.flowdata, r, c, "fc");

    //若单元格有交替颜色 文本颜色
    if (checksAF != null && checksAF[0] != null) {
        tableCtx.fillStyle = checksAF[0];
    }
    //若单元格有条件格式 文本颜色
    if (checksCF != null && checksCF["textColor"] != null) {
        tableCtx.fillStyle = checksCF["textColor"];
    }

    renderCellText(textInfo, tableCtx, {
        pos_x: pos_x,
        pos_y: pos_y,
        visible: cellProtectionCtrl.isVisible(r, c),
    });

    tableCtx.restore();
}

/**
 * @description 渲染单元格图片
 */
function renderCellImage(tableCtx, f, pos, drawParams) {
    // =DISPIMG('img_wx5a6n0A1ael_1600925814407',2)
    // 匹配DISPIMG函数的正则表达式
    const dispImgRegex = /=*DISPIMG\(['"]([^'"]+)['"],(\d+)\)/;
    const match = f.match(dispImgRegex);
    if (!match) return;

    // 解析图片ID和显示模式
    const imgID = match[1]; // 图片ID: img_wx5a6n0A1ael_1600925814407
    const mode = match[2]; // 显示模式: 2

    // 这里传过去的参数是 cell 哈，因此绘制时，需要具体的位置信息
    const { scrollWidth, scrollHeight, offsetLeft, offsetTop, drawWidth, drawHeight } = drawParams;
    cellImageCtrl.luckysheetDrawCellImage(tableCtx, pos, imgID, mode, scrollWidth, scrollHeight, drawWidth, drawHeight, offsetLeft, offsetTop);
}

/**
 * @description 渲染合并单元格
 */
function renderMergeCell(tableCtx, cellupdate, drawParams) {
    const mergeCellData = parseMergeCellData(cellupdate);
    if (mergeCellData.length == 0) return;

    const { scrollWidth, scrollHeight, offsetLeft, offsetTop, printGridLine, dynamicArray_compute } = drawParams;

    for (let mergeCell of mergeCellData) {
        let { r, c, start_r, start_c, end_r, end_c, value = null } = mergeCell;
        end_r = end_r - 1;
        end_c = end_c - 1;

        // 获取当前合并单元格的主单元格信息
        let cell = Store.flowdata[r][c];
        const mergeConfig = cell["mc"];

        value = getRealCellValue(mergeConfig.r, mergeConfig.c);

        r = mergeConfig.r;
        c = mergeConfig.c;

        const mainCell = Store.flowdata[r][c];

        // 起始行列坐标计算
        start_c = !c ? -scrollWidth : Store.visibledatacolumn[c - 1] - scrollWidth;
        start_r = !r ? -scrollHeight - 1 : Store.visibledatarow[r - 1] - scrollHeight - 1;

        // 结束行列坐标计算
        end_r = Store.visibledatarow[r + mainCell["mc"].rs - 1] - scrollHeight;
        end_c = Store.visibledatacolumn[c + mainCell["mc"].cs - 1] - scrollWidth;

        if (value == null || value.toString().length == 0) {
            renderEmptyCell({ tableCtx, cellInfo: mergeCell, drawParams, isMerge: true });

            //sparklines渲染
            let borderfix = menuButton.borderfix(Store.flowdata, r, c);
            let cellsize = [
                start_c + offsetLeft + borderfix[0],
                start_r + offsetTop + borderfix[1],
                end_c - start_c - 3 + borderfix[2],
                end_r - start_r - 3 - 1 + borderfix[3],
            ];
            renderSparklines(r, c, cellsize[0], cellsize[1], "luckysheetTableContent", tableCtx);
        } else {
            if (r + "_" + c in dynamicArray_compute) {
                //动态数组公式
                value = dynamicArray_compute[r + "_" + c].v;
            }
            renderEntityCell({ tableCtx, cellInfo: { r, c, start_r, start_c, end_r, end_c, value }, drawParams, isMerge: true });
        }

        // 兼容下 DISPIMG 类型的单元格
        if (mainCell.f && mainCell.f.includes("DISPIMG")) {
            renderCellImage(tableCtx, mainCell.f, mergeCell, drawParams);
        }
    }
}

/**
 * @description 数据透视表边框渲染
 */
function renderPivotTableBorder(tableCtx, drawParams) {
    const { scrollWidth, scrollHeight, offsetLeft, offsetTop, dataset_row_st, dataset_row_ed, dataset_col_st, dataset_col_ed } = drawParams;

    for (let r = dataset_row_st; r <= dataset_row_ed; r++) {
        let start_r;
        let end_r = Store.visibledatarow[r] - scrollHeight;

        if (r == 0) start_r = -scrollHeight - 1;
        else start_r = Store.visibledatarow[r - 1] - scrollHeight - 1;

        for (let c = dataset_col_st; c <= dataset_col_ed; c++) {
            let start_c;
            let end_c = Store.visibledatacolumn[c] - scrollWidth;

            if (c == 0) start_c = -scrollWidth;
            else start_c = Store.visibledatacolumn[c - 1] - scrollWidth;

            //数据透视表
            if (!!Store.luckysheetcurrentisPivotTable && pivotTable.drawPivotTable) {
                if ((c == 0 || c == 5) && r <= 11) {
                    tableCtx.beginPath();
                    tableCtx.moveTo(end_c - 1 + offsetLeft, start_r + offsetTop);
                    tableCtx.lineTo(end_c - 1 + offsetLeft, end_r - 1 + offsetTop);
                    tableCtx.lineWidth = 1;
                    tableCtx.strokeStyle = "#000000";
                    tableCtx.closePath();
                    tableCtx.stroke();
                }

                if ((r == 2 || r == 11) && c <= 5) {
                    tableCtx.beginPath();
                    tableCtx.moveTo(start_c - 1 + offsetLeft, end_r - 1 + offsetTop);
                    tableCtx.lineTo(end_c - 1 + offsetLeft, end_r - 1 + offsetTop);
                    tableCtx.lineWidth = 1;
                    tableCtx.strokeStyle = "#000000";
                    tableCtx.closePath();
                    tableCtx.stroke();
                }

                if (r == 6 && c == 3) {
                    tableCtx.save();
                    tableCtx.font = "bold 30px Arial";
                    tableCtx.fillStyle = "#626675";
                    tableCtx.textAlign = "center";
                    tableCtx.fillText(
                        locale().pivotTable.title,
                        start_c + (end_c - start_c) / 2 + 4 + offsetLeft,
                        start_r + (end_r - start_r) / 2 - 1 + offsetTop,
                    );
                    tableCtx.restore();
                }
            } else if (!!Store.luckysheetcurrentisPivotTable) {
                if (c < pivotTable.pivotTableBoundary[1] && r < pivotTable.pivotTableBoundary[0]) {
                    tableCtx.beginPath();
                    tableCtx.moveTo(end_c - 1 + offsetLeft, start_r + offsetTop);
                    tableCtx.lineTo(end_c - 1 + offsetLeft, end_r - 1 + offsetTop);
                    tableCtx.lineWidth = 1;
                    tableCtx.strokeStyle = "#000000";
                    tableCtx.closePath();
                    tableCtx.stroke();

                    tableCtx.beginPath();
                    tableCtx.moveTo(start_c - 1 + offsetLeft, end_r - 1 + offsetTop);
                    tableCtx.lineTo(end_c - 1 + offsetLeft, end_r - 1 + offsetTop);
                    tableCtx.lineWidth = 1;
                    tableCtx.strokeStyle = "#000000";
                    tableCtx.closePath();
                    tableCtx.stroke();
                }
            }
        }
    }
}

/**
 * @description 绘制边框 - borderInfo 这个是 File.config["borderInfo"] 的边框
 */
function renderBorderInfo(borderOffset, canvas, drawParams) {
    if (Store.config["borderInfo"] == null || Store.config["borderInfo"].length == 0) return;

    const { scrollWidth, scrollHeight, offsetLeft, offsetTop, dataset_row_st, dataset_row_ed, dataset_col_st, dataset_col_ed, cellOverflowMap } = drawParams;

    const borderInfoCompute = getBorderInfoComputeRange(dataset_row_st, dataset_row_ed, dataset_col_st, dataset_col_ed);

    for (let x in borderInfoCompute) {
        const bd_r = x.substr(0, x.indexOf("_"));
        const bd_c = x.substr(x.indexOf("_") + 1);

        if (!borderOffset[bd_r + "_" + bd_c]) continue;

        const start_r = borderOffset[bd_r + "_" + bd_c].start_r;
        const start_c = borderOffset[bd_r + "_" + bd_c].start_c;
        const end_r = borderOffset[bd_r + "_" + bd_c].end_r;
        const end_c = borderOffset[bd_r + "_" + bd_c].end_c;

        const { colIn, stc, colLast } = cellOverflow_colIn(cellOverflowMap, bd_r, bd_c, dataset_col_st, dataset_col_ed);

        /** 如果 borderInfo 有值，则提前计算属性，合并使用 */
        // 这里是绘制线条，则属性分别为 moveTo lineTo
        // ⚠️ 这里的0.5 是为了重叠相邻两个边框的位置，避免渲染出 2px 的边框
        const m_x = start_c + offsetLeft - 0.5; // move_x
        const m_y = start_r + offsetTop + 0.5; // move_y
        const l_x = end_c + offsetLeft - 0.5; // line_x
        const l_y = end_r + offsetTop - 0.5; // line_y

        // 左边框
        const borderLeft = borderInfoCompute[x].l;
        if (borderLeft != null && (!colIn || stc == bd_c)) {
            drawBorder(canvas, borderLeft, m_x, m_y, m_x, l_y, "v");
        }

        // 右边框
        const borderRight = borderInfoCompute[x].r;
        if (borderRight != null && (!colIn || colLast)) {
            drawBorder(canvas, borderRight, l_x, m_y, l_x, l_y, "v");
        }

        // 上边框
        const borderTop = borderInfoCompute[x].t;
        if (borderTop != null) {
            drawBorder(canvas, borderTop, m_x, m_y, l_x, m_y, "h");
        }

        // 下边框
        const borderBottom = borderInfoCompute[x].b;
        if (borderBottom != null) {
            drawBorder(canvas, borderBottom, m_x, l_y, l_x, l_y, "h");
        }

        // 左斜线
        const border_rt_lb = borderInfoCompute[x].rt_lb;
        if (border_rt_lb != null) {
            // 从 Store.visibledatarow 中获取真实的页面坐标
            const { sr, sc, er, ec } = getSlashMergeCell(bd_r, bd_c, start_r, start_c, end_r, end_c, scrollHeight, scrollWidth);
            const line_st_x = ec + offsetLeft;
            const line_st_y = sr + offsetTop;
            const line_ed_x = sc + offsetLeft;
            const line_ed_y = er + offsetTop;
            drawBorder(canvas, border_rt_lb, line_st_x, line_st_y, line_ed_x, line_ed_y, "rt_lb"); // 最后传神么都无所谓 会走 else
        }

        // 右斜线
        const border_lt_rb = borderInfoCompute[x].lt_rb;
        if (border_lt_rb != null) {
            const { sr, sc, er, ec } = getSlashMergeCell(bd_r, bd_c, start_r, start_c, end_r, end_c, scrollHeight, scrollWidth);
            const line_st_x = sc + offsetLeft;
            const line_st_y = sr + offsetTop;
            const line_ed_x = ec + offsetLeft;
            const line_ed_y = er + offsetTop;
            drawBorder(canvas, border_lt_rb, line_st_x, line_st_y, line_ed_x, line_ed_y, "lt_rb"); // 最后传神么都无所谓 会走 else
        }
    }
}

/**
 * @description 渲染单元格文本
 * @param {*} textInfo
 * @param {*} option
 * @returns
 */
function renderCellText(textInfo, ctx, option) {
    if (textInfo == null) {
        return;
    }
    let values = textInfo.values;
    let pos_x = option.pos_x,
        pos_y = option.pos_y;
    if (values == null) {
        return;
    }

    // 这里是兼容单元格保护权限中的用户仅查看 | 可编辑 | 不可查看权限
    if (option.visible === false) return;

    if (textInfo.rotate != 0 && textInfo.type != "verticalWrap") {
        ctx.save();
        ctx.translate((pos_x + textInfo.textLeftAll) / Store.zoomRatio, (pos_y + textInfo.textTopAll) / Store.zoomRatio);
        ctx.rotate((-textInfo.rotate * Math.PI) / 180);
        ctx.translate(-(textInfo.textLeftAll + pos_x) / Store.zoomRatio, -(pos_y + textInfo.textTopAll) / Store.zoomRatio);
    }

    // ctx.fillStyle = "rgb(0,0,0)";
    for (let i = 0; i < values.length; i++) {
        let word = values[i];
        if (word.inline === true && word.style != null) {
            ctx.font = word.style.fontset;
            ctx.fillStyle = word.style.fc;
        } else {
            ctx.font = word.style;
        }

        // 暂时未排查到word.content第一次会是object，先做下判断来渲染，后续找到问题再复原
        let txt = typeof word.content === "object" ? word.content.m : word.content;
        ctx.fillText(txt, (pos_x + word.left) / Store.zoomRatio, (pos_y + word.top) / Store.zoomRatio);

        if (word.cancelLine != null) {
            let c = word.cancelLine;
            ctx.beginPath();
            ctx.moveTo(Math.floor((pos_x + c.startX) / Store.zoomRatio) + 0.5, Math.floor((pos_y + c.startY) / Store.zoomRatio) + 0.5);
            ctx.lineTo(Math.floor((pos_x + c.endX) / Store.zoomRatio) + 0.5, Math.floor((pos_y + c.endY) / Store.zoomRatio) + 0.5);
            ctx.lineWidth = Math.floor(c.fs / 9);
            ctx.strokeStyle = ctx.fillStyle;
            ctx.stroke();
            ctx.closePath();
        }

        if (word.underLine != null) {
            let underLines = word.underLine;
            for (let a = 0; a < underLines.length; a++) {
                let item = underLines[a];
                ctx.beginPath();
                ctx.moveTo(Math.floor((pos_x + item.startX) / Store.zoomRatio) + 0.5, Math.floor((pos_y + item.startY) / Store.zoomRatio));
                ctx.lineTo(Math.floor((pos_x + item.endX) / Store.zoomRatio) + 0.5, Math.floor((pos_y + item.endY) / Store.zoomRatio) + 0.5);
                ctx.lineWidth = Math.floor(item.fs / 9);
                ctx.strokeStyle = ctx.fillStyle;
                ctx.stroke();
                ctx.closePath();
            }
        }
    }

    // 是否需要重置状态
    if (textInfo.rotate != 0 && textInfo.type != "verticalWrap") ctx.restore();
}

/**
 * @description 解决打印时，左上边框不显示问题
 */
function renderPrintBorder(ctx, r, c, cellsize) {
    if (r && c) return; // 只渲染左边和上边的边框

    const [x, y, w, h] = cellsize;

    // 第一行单元格，绘制上边框
    if (r === 0) drawCellBorder(ctx, x, -0.25, x + w, -0.25);

    // 第一列单元格，绘制左边框
    if (c === 0) drawCellBorder(ctx, -0.25, y, -0.25, y + h);
}

export { luckysheetDrawMain, luckysheetDrawgridRowTitle, luckysheetDrawgridColumnTitle };
